module.exports = __webpack_public_path__ + "static/media/hydraulic-hose-mr-card-back.6e00288e.jpeg";